import { render, staticRenderFns } from "./CoretechnologyView.vue?vue&type=template&id=3a70edf9&scoped=true"
import script from "./CoretechnologyView.vue?vue&type=script&lang=js"
export * from "./CoretechnologyView.vue?vue&type=script&lang=js"
import style0 from "./CoretechnologyView.vue?vue&type=style&index=0&id=3a70edf9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70edf9",
  null
  
)

export default component.exports